module.exports = __webpack_public_path__ + "img/w2.b6e13cd6.png";